import React, {Component, PropTypes} from 'react';

// Stores and Actions
import mapStore from '../../stores/map'
import mapActions from '../../actions/map';
import StoreConnect from '../../flux/StoreConnect'

// Subviews
import SeatBlock from './svg/seatBlock';
import Polygon from './svg/polygon';
import Label from './svg/label';

import config from '../../config';

class SIMSvgMap extends Component {

  /**
   * Used to determine if a section is currently active
   * @param sectionId
   * @returns {boolean}
   */
  isActiveSection (sectionId) {
    return config.system.showAllSeats || !this.props.static && sectionId === this.props.map.activeSection;
  }

  isGA (section) {
    return section.isGA || !config.system.showSeats;
  }

  /**
   * TODO, check if still used and valid
   * @param sectionId
   * @returns {boolean}
   */
  isHighlightedSection (sectionId) {
    return this.props.static && sectionId === this.props.map.activeSection;
  }

  /**
   * Returns list of all seatBlocks
   * @returns {Array}
   */
  renderSeatBlocks () {
    return this.props.map.geometry.map((section) => {
      // ignore General Admissions
      if (this.isActiveSection(section.id) && !this.isGA(section) && !this.props.static) {
        return (
          <SeatBlock
            {...section}
            key={section.id}
            activeSeats={this.props.map.activeSeats}/>
        );
      }
    });
  }

  /**
   * Returns a list of all Polygons
   * @returns {Array}
   */
  renderPolygons () {
    return this.props.map.geometry.map((section, idx) => {
      return (
        <Polygon
          {...section.polygon}
          key={idx}
          sectionId={section.id}
          code={section.code}
          isActive={this.isActiveSection(section.id)}
          isHighlighted={this.isHighlightedSection(section.id)}
          isOverviewMode={!config.system.showSeats}
          available={section.availableSeatCount>0}
          isGA={this.isGA(section)}
          priceCategories={section.priceCategories}
          static={this.props.static}/>
      );
    });
  }

  /**
   * Returns a list of all Labels
   * @returns {Array}
   */
  renderLabels () {
    return this.props.map.geometry.map((section) => {
      // input :
      // 1) has label
      // 2) is static map
      // 3) isGA
      // 4) isActive
      // TODO, improve this to not render hidden labels
      if (section.label) {
        return (
          <Label
            {...section.label}
            key={section.id}
            showSeats={!this.isGA(section) && this.isActiveSection(section.id)}/>
        );
      }
    });
  }

  /**
   * Returns a list of all Polygons
   * @returns {Element}
   */
  renderSvgMap () {
    const bgStyle = {
      backgroundImage: config.geometry.bg ? 'url(' + config.geometry.bg + ')' : 'none'
    };

    return (
      <svg data-component="svg" className="map__svg" viewBox="0 0 10240 7680" style={bgStyle}>
        <g className="polygons">{this.renderPolygons()}</g>
        <g className="seats">{this.renderSeatBlocks()}</g>
        <g className="labels">{this.renderLabels()}</g>
      </svg>
    );
  }

  /**
   * @returns {boolean|Component}
   */
  render () {
    if (!this.props.map || this.props.map.fatalError || !this.props.map.geometry || !this.props.map.geometry.length) {
      return false;
    }

    const imageURL = config.geometry.bg || 'none';
    const isIE = navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode == true;
    const svgElement = this.renderSvgMap();

    // IE doesn't display .swf images as a background-image, so to support here's the object tag

    return isIE ? (
      <div className="map__svg-container">
        <object height="100%" width="100%" className="map__object" data={imageURL} type="application/x-shockwave-flash">
          <param name="wmode" value="transparent" />
        </object>
        {svgElement}
      </div>
    ) : (
      svgElement
    );
  }
}

SIMSvgMap.propTypes = {
  static: PropTypes.bool,
  map:    PropTypes.shape({
    fatalError:    PropTypes.bool.isRequired,
    activeSeats:   PropTypes.array.isRequired,
    activeSection: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    geometry:      PropTypes.oneOfType([PropTypes.array, PropTypes.bool]).isRequired
  })
};

export default StoreConnect(SIMSvgMap, {map: mapStore});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/index.jsx